import { useState } from 'react';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { useInitialCheck } from '../../../utils';


export default function CustomDonutChart({data=[], propConst=0.03, percentage, hasData}: any) {
    const [width, setWidth]   = useState(window.innerWidth)
    const [height, setHeight] = useState(window.innerHeight)
    
    setInterval(updateDimensions, 200)
    const propDim = Math.floor(Math.sqrt(width*width + height*height)) * propConst

    function updateDimensions(){
        if(window.innerWidth != width)
            setWidth(window.innerWidth)

        if(window.innerHeight != height)
            setHeight(window.innerHeight)
    }

    const defaultData = [
        { name: 'Não há dados', value: 1, color: 'grey' },
    ]

    if(hasData == false){
        data = defaultData
    }

    return (
        <ResponsiveContainer width="100%" height="100%"> 
            <PieChart>
                <Pie
                    dataKey="value"
                    data={data}
                    cx="50%"
                    cy="50%"
                    outerRadius={propDim}
                    innerRadius={propDim -35}
                    paddingAngle={0}
                    stroke="none"
                    label={({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: any) => {
                        const RADIAN = Math.PI / 180;
                        // Calcula a posição do rótulo
                        const radius = innerRadius + (outerRadius - innerRadius) * 0.2;
                        const x = cx + radius * Math.cos(-midAngle * RADIAN);
                        const y = cy + radius * Math.sin(-midAngle * RADIAN);
                        return (
                          <text x={x} y={y} fontSize={'14px'} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                            {`${(percent * 100).toFixed(0)}%`}
                          </text>
                        );
                      }}
                    labelLine={false}
                >
                    {
                        data.map((entry: any, index: any) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))
                    }
                </Pie>
                <Tooltip />
            </PieChart>
        </ResponsiveContainer>
    );
}
